function g(e, t) {
  var n = t && t.cache ? t.cache : y, r = t && t.serializer ? t.serializer : p, c = t && t.strategy ? t.strategy : l;
  return c(e, {
    cache: n,
    serializer: r
  });
}
function s(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function f(e, t, n, r) {
  var c = s(r) ? r : n(r), a = t.get(c);
  return typeof a > "u" && (a = e.call(this, r), t.set(c, a)), a;
}
function u(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), c = n(r), a = t.get(c);
  return typeof a > "u" && (a = e.apply(this, r), t.set(c, a)), a;
}
function o(e, t, n, r, c) {
  return n.bind(t, e, r, c);
}
function l(e, t) {
  var n = e.length === 1 ? f : u;
  return o(e, this, n, t.cache.create(), t.serializer);
}
function h(e, t) {
  return o(e, this, u, t.cache.create(), t.serializer);
}
var p = function() {
  return JSON.stringify(arguments);
};
function i() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
i.prototype.get = function(e) {
  return this.cache[e];
};
i.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var y = {
  create: function() {
    return new i();
  }
}, v = {
  variadic: h
};
export {
  g as memoize,
  v as strategies
};
